import Index from "../components/login/Index.vue"
import init from "../root_init"
init(Index)
